import TipoBeneficioEnum from '@/enums/TipoBeneficioEnum';
import TipoRequisitoEnum from '@/enums/TipoRequisitoEnum';

export default class RequisitoBeneficio {
    constructor(
        public secuencia?: string,
        public aplicaTramite?: boolean,
        public requisitos?: Requisito[],
        public afiliadoInabima?: boolean
    ) {}
}

class Requisito {
    constructor(
        public codRequisito?: number,
        public descripcion?: string,
        public esObligatorio?: boolean,
        public cumpleRequisito?: boolean,
    ) {}
}

class ParametrosValidacionRequisitosBeneficio {
    constructor(
        public cedulaAfiliado?: string,
        public codCuenta?: string,
        public tipoRequisito?: TipoRequisitoEnum,
        public codBeneficio?: TipoBeneficioEnum
    ) {}
}
export { Requisito, ParametrosValidacionRequisitosBeneficio }